export enum SectionType {
    BANNER = 2,
    PRODUCT_LIST = 3,
}

export const getSectionType = (type: SectionType) => {
    switch (type) {
        case SectionType.BANNER:
            return "banner";
        case SectionType.PRODUCT_LIST:
            return "product_list";

        default:
            return "banner";
    }
};